module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/NB_FC线：Underfill点胶设备.3514cdee.png";